/**
 * Ekiboost - Free shipping bar dynamic update
 * Met a jour la barre de livraison quand le panier change via AJAX
 */
(function() {
  var FREE_SHIPPING_THRESHOLD = 6000; // 60 EUR en centimes
  var SHIPPING_COST = '4,90\u00a0\u20ac'; // 4,90 €
  var MAX_CART_ITEMS = 100;

  // Limite 100 articles par panier
  function enforceCartLimit() {
    var forms = document.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var cartCount = parseInt(document.querySelector('[data-cart-count]')?.textContent || '0', 10);
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (cartCount + qty > MAX_CART_ITEMS) {
          e.preventDefault();
          alert('Le panier est limité à ' + MAX_CART_ITEMS + ' produits.');
        }
      });
    });
  }

  function updateFreeShippingBars(subtotal) {
    var bars = document.querySelectorAll('.free-shipping-bar');
    if (!bars.length) return;

    var remaining = FREE_SHIPPING_THRESHOLD - subtotal;
    var isFree = subtotal >= FREE_SHIPPING_THRESHOLD;
    var progressPercent = Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100));

    bars.forEach(function(bar) {
      var message = bar.querySelector('.free-shipping-bar__message');
      var fill = bar.querySelector('.free-shipping-bar__progress-fill');

      if (isFree) {
        if (message) {
          message.className = 'free-shipping-bar__message free-shipping-bar__message--success';
          message.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Livraison offerte !</span>';
        }
      } else {
        if (message) {
          message.className = 'free-shipping-bar__message';
          message.innerHTML = '<span>Plus que <strong>' + theme.Currency.formatMoney(remaining, theme.settings.moneyFormat) + '</strong> pour la livraison offerte</span>';
        }
      }

      if (fill) {
        fill.style.width = progressPercent + '%';
      }
    });

    // Update shipping info text
    var shippingInfos = document.querySelectorAll('.cart__shipping-info');
    shippingInfos.forEach(function(el) {
      if (isFree) {
        el.className = 'cart__shipping-info cart__shipping-info--free';
        el.textContent = el.closest('.cart__item-row.text-center') ? 'Livraison gratuite' : 'Gratuite';
      } else {
        el.className = 'cart__shipping-info';
        el.innerHTML = el.closest('.cart__item-row.text-center') ? 'Livraison : ' + SHIPPING_COST : SHIPPING_COST;
      }
    });
  }

  // Hook into Impulse's cart update via MutationObserver on subtotal
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.hasAttribute && mutation.target.hasAttribute('data-subtotal')) {
        // Subtotal text changed, find the cart total from the AJAX data
        var cartItems = document.querySelector('.cart__items');
        if (cartItems && cartItems.dataset.cartSubtotal) {
          updateFreeShippingBars(parseInt(cartItems.dataset.cartSubtotal, 10));
        }
      }
    });
  });

  // Observe all data-subtotal elements
  function initObservers() {
    document.querySelectorAll('[data-subtotal]').forEach(function(el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initObservers();
      enforceCartLimit();
    });
  } else {
    initObservers();
    enforceCartLimit();
  }
})();
